import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchWaSession } from '../../../utils/adminWhatsapp';
import { stageBadgeClass, stageLabel, stateBadgeClass, stateLabel } from './waStageLabels';
import { opsMonitorUrl } from '../../../utils/adminWhatsapp';

export default function WaSessionDrawer({ sessionId, onClose, onHandoff }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!sessionId) return;
    setLoading(true);
    fetchWaSession(sessionId)
      .then((r) => setSession(r.session))
      .catch(() => setSession(null))
      .finally(() => setLoading(false));
  }, [sessionId]);

  if (!sessionId) return null;

  const cart = session?.booking_cart || {};
  const acfId = session?.acf_booking_id;

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <button type="button" className="flex-1 bg-black/30" onClick={onClose} aria-label="Close" />
      <div className="w-full max-w-md bg-white shadow-xl h-full overflow-y-auto p-5">
        <div className="flex justify-between items-start mb-4">
          <h2 className="font-bold text-[#1B375B]">Session</h2>
          <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-800">✕</button>
        </div>
        {loading ? (
          <p className="text-sm text-gray-500">Loading…</p>
        ) : !session ? (
          <p className="text-sm text-red-600">Failed to load</p>
        ) : (
          <>
            <p className="font-mono text-sm">{session.phone_masked}</p>
            <p className="text-sm text-gray-600">{session.customer_name}</p>
            <div className="flex gap-2 mt-2 flex-wrap">
              <span className={`text-xs px-2 py-0.5 rounded-full ${stageBadgeClass(session.stage)}`}>
                {stageLabel(session.stage)}
              </span>
              <span className={`text-xs px-2 py-0.5 rounded-full ${stateBadgeClass(session.state)}`}>
                {stateLabel(session.state)}
              </span>
            </div>
            <div className="mt-4 border rounded-lg p-3 text-sm bg-gray-50">
              <p><strong>Route:</strong> {cart.origin_iata || '—'} → {cart.destination_iata || '—'}</p>
              <p><strong>Date:</strong> {cart.travel_date || '—'}</p>
              <p><strong>Total:</strong> ₹{cart.total_inr ?? '—'}</p>
              <p><strong>Pax:</strong> {(cart.pax_list || []).length} / {cart.pax_total || '—'}</p>
            </div>
            {session.ai_context?.length > 0 && (
              <div className="mt-3">
                <p className="text-xs font-semibold text-gray-500 mb-1">Recent NLU</p>
                <ul className="text-xs space-y-1 max-h-24 overflow-y-auto">
                  {session.ai_context.slice(-5).map((e, i) => (
                    <li key={i} className="text-gray-600">
                      {e.intent || e.kind}: {e.text?.slice(0, 60)}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className="mt-6 flex flex-col gap-2">
              <Link
                to={`/admin/whatsapp/session/${sessionId}`}
                className="text-center py-2 text-sm border border-[#659A9B] text-[#659A9B] rounded-lg"
              >
                View transcript
              </Link>
              {acfId && (
                <a
                  href={opsMonitorUrl(acfId)}
                  className="text-center py-2 text-sm bg-[#1B375B] text-white rounded-lg"
                >
                  Open in Ops Monitor
                </a>
              )}
              <button
                type="button"
                onClick={() => onHandoff?.(sessionId)}
                className="py-2 text-sm text-red-600 border border-red-200 rounded-lg"
              >
                Force handoff
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
